import { useState, useEffect } from "react";
import { fetchTableByToken } from "../api/reviewApi";

export const useTokenValidation = (token) => {
  const [isValidToken, setIsValidToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validate = async () => {
      if (!token) {
        setIsValidToken(false);
        setIsLoading(false);
        return;
      }

      try {
        await fetchTableByToken(token);
        setIsValidToken(true);
      } catch (err) {
        console.error("Invalid token:", err);
        setIsValidToken(false);
      } finally {
        setIsLoading(false);
      }
    };

    validate();
  }, [token]);

  return { isValidToken, isLoading };
};